<template>
  <div class="container-fluid">
    <account-info></account-info>

    <choose-package></choose-package>
    <div class="declaration">
      <span>{{ $t('declaration') }}</span>
      <p v-for="(item, index) in $t('declarationList')" :key="index" class="declaration-list">
        <span class="index">{{ index + 1 }}</span>
        {{ item }}
      </p>
    </div>

    <pay-status-notice></pay-status-notice>
  </div>
</template>

<script>
  import $ from 'jquery'
  import AccountInfo from './accountInfo/Index.vue'
  import InviteFriend from '../../components/inviteFriend/InviteFriend.vue'
  import ChoosePackage from '../../components/dashboard/choosePackage/ChoosePackage.vue'
  import Notification from '../notification/Notification.vue'
  import PayStatusNotice from '../../components/payStatusNotice/PayStatusNotice.vue'
  import locales from './lang'

  export default {
    name: 'dashboard',
    components: {InviteFriend, ChoosePackage, Notification, PayStatusNotice, AccountInfo},
    locales,
    computed: {
      user() {
        return this.$store.state.user
      }
    },
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "dashboard";
</style>



// WEBPACK FOOTER //
// Index.vue?1a4aca37